/** LeninkaArt-compatible permission strings (nbr-api/internal/platform/perms). */
export const NbrPermission = {
  EventsCreate: "LeninkaArt.Events.Create",
  EventsEdit: "LeninkaArt.Events.Edit",
  EventsApprove: "LeninkaArt.Events.Approve",
  EventsApproveRegistration: "LeninkaArt.Events.ApproveRegistration",
  DepositsModerate: "LeninkaArt.Deposits.Moderate",
  AssociationsManage: "LeninkaArt.Associations.Manage",
  AssociationsVerify: "LeninkaArt.Associations.Verify",
  AuditEventsView: "LeninkaArt.Audit.Events.View",
  AuditDepositsView: "LeninkaArt.Audit.Deposits.View",
  AuditDefault: "LeninkaArt.Audit",
  EventsDefault: "LeninkaArt.Events",
  AssociationsDefault: "LeninkaArt.Associations",
  UserLookupSearch: "LeninkaArt.UserLookup.Search",
  CreativeSelfManageCatalog: "LeninkaArt.CreativeSelfDefinition.ManageCatalog",
} as const

export type NbrPermissionName = (typeof NbrPermission)[keyof typeof NbrPermission]

const industryModeratePrefix = "LeninkaArt.Deposits.Moderate.Industry."

/** Exact + hierarchical matching aligned with server `perms.Has`. */
export const hasPermission = (granted: readonly string[], want: string): boolean => {
  for (const g of granted) {
    if (g === want) return true
    if (g === NbrPermission.DepositsModerate && want.startsWith(industryModeratePrefix)) return true
    if (
      g === NbrPermission.AuditDefault &&
      (want === NbrPermission.AuditEventsView ||
        want === NbrPermission.AuditDepositsView ||
        want === "LeninkaArt.Audit.Associations.View")
    ) {
      return true
    }
    if (
      g === NbrPermission.EventsDefault &&
      (want === NbrPermission.EventsCreate ||
        want === NbrPermission.EventsEdit ||
        want === NbrPermission.EventsApprove ||
        want === NbrPermission.EventsApproveRegistration)
    ) {
      return true
    }
    if (
      g === NbrPermission.AssociationsDefault &&
      (want === NbrPermission.AssociationsVerify || want === NbrPermission.AssociationsManage)
    ) {
      return true
    }
  }
  return false
}

export const canModerateDeposits = (granted: readonly string[]): boolean =>
  hasPermission(granted, NbrPermission.DepositsModerate) ||
  granted.some((g) => g.startsWith(industryModeratePrefix))
